import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '../../ds';
import { ScheduleGroup } from '../../schedules';
import { DayChips } from '../controls';
import { PencilIcon, TrashIcon } from '../icons';
import {
  CardActions, CardDays, CardHeader, CardHeaderTitle, InfoGrid, ScheduleCardBox,
} from './styles';

interface ScheduleCardProps {
  group: ScheduleGroup;
  title: string;
  /** Sem ações, o card fica só para leitura. */
  actions: { onEdit: () => void; onRemove: () => void; disabled: boolean } | null;
}

export function ScheduleCard({ group, title, actions }: Readonly<ScheduleCardProps>): ReactElement {
  const { t } = useTranslation();
  const editLabel = t('ecoSimplificadoEditarProgramacaoNome', { titulo: title, interpolation: { escapeValue: false } });
  const removeLabel = t('ecoSimplificadoExcluirProgramacaoNome', { titulo: title, interpolation: { escapeValue: false } });

  return (
    <ScheduleCardBox data-testid="eco-simplificado-card-programacao">
      <CardHeader>
        <CardHeaderTitle>{title}</CardHeaderTitle>
        {actions ? (
          <CardActions>
            <IconButton type="button" title={editLabel} aria-label={editLabel} disabled={actions.disabled} onClick={actions.onEdit}>
              <PencilIcon />
            </IconButton>
            <IconButton type="button" $danger title={removeLabel} aria-label={removeLabel} disabled={actions.disabled} onClick={actions.onRemove}>
              <TrashIcon />
            </IconButton>
          </CardActions>
        ) : null}
      </CardHeader>
      <InfoGrid>
        <span>{t('funcionamento')}</span>
        <span>{t(group.permission === 'allow' ? 'ecoSimplificadoPermitir' : 'ecoSimplificadoBloquearCurto')}</span>
        <span>{t('ecoSimplificadoHorarioDeInicio')}</span>
        <span>{group.start}</span>
        <span>{t('ecoSimplificadoHorarioDeFim')}</span>
        <span>{group.end}</span>
      </InfoGrid>
      <CardDays>
        <DayChips selected={group.days} />
      </CardDays>
    </ScheduleCardBox>
  );
}
